import React, { Component } from 'react';
import { database } from '../firebase';
import { ref, set, onValue, off, onDisconnect, serverTimestamp, runTransaction } from 'firebase/database';
import './VisitorCounter.css';

class VisitorCounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onlineVisitors: 0,
      totalVisitors: 0,
      isLoading: true
    };
    this.sessionId = this.generateSessionId();
    this.visitorRef = null;
    this.onlineRef = null;
  }

  generateSessionId() {
    return Date.now() + '-' + Math.random().toString(36).substr(2, 9);
  }

  componentDidMount() {
    this.initializeVisitorTracking();
  }

  componentWillUnmount() {
    // Clean up when component unmounts
    if (this.visitorRef) {
      // Remove the session from database
      set(this.visitorRef, null);
    }
    if (this.onlineListener) {
      off(this.onlineRef, 'value', this.onlineListener);
    }
    if (this.totalListener) {
      off(ref(database, 'visitors/total'), 'value', this.totalListener);
    }
  }

  initializeVisitorTracking() {
    // Reference for online visitors
    this.onlineRef = ref(database, 'visitors/online');
    this.visitorRef = ref(database, `visitors/online/${this.sessionId}`);
    
    // Reference for total visitor count
    const totalRef = ref(database, 'visitors/total');
    
    // Set this session as online
    set(this.visitorRef, {
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent.substring(0, 100) // Limit length
    });
    
    // Remove this session when user disconnects
    onDisconnect(this.visitorRef).remove();
    
    // Listen for online visitors count
    this.onlineListener = onValue(this.onlineRef, (snapshot) => {
      const onlineCount = snapshot.size;
      this.setState({ onlineVisitors: onlineCount, isLoading: false });
    });
    
    // Increment total visitor count
    runTransaction(totalRef, (currentValue) => {
      return (currentValue || 0) + 1;
    });
    
    // Listen for total visitors count
    this.totalListener = onValue(totalRef, (snapshot) => {
      const totalCount = snapshot.val() || 0;
      this.setState({ totalVisitors: totalCount });
    });
    
    // Clean up old offline sessions (optional - removes sessions older than 5 minutes)
    this.cleanupOldSessions();
  }

  cleanupOldSessions() {
    const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
    
    const onlineRef = ref(database, 'visitors/online');
    onValue(onlineRef, (snapshot) => {
      const sessions = snapshot.val();
      if (sessions) {
        Object.keys(sessions).forEach((sessionId) => {
          const session = sessions[sessionId];
          if (session.timestamp < fiveMinutesAgo) {
            set(ref(database, `visitors/online/${sessionId}`), null);
          }
        });
      }
    }, { onlyOnce: true });
  }

  formatNumber(num) {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  }

  render() {
    const { onlineVisitors, totalVisitors, isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="visitor-counter loading">
          <div className="counter-item">
            <span className="counter-icon">👥</span>
            <span className="counter-text">Loading...</span>
          </div>
        </div>
      );
    }

    return (
      <div className="visitor-counter">
        <div className="counter-item online">
          <span className="counter-icon">🟢</span>
          <span className="counter-number">{this.formatNumber(onlineVisitors)}</span>
          <span className="counter-label">Online</span>
        </div>
        <div className="counter-separator">|</div>
        <div className="counter-item total">
          <span className="counter-icon">📊</span>
          <span className="counter-number">{this.formatNumber(totalVisitors)}</span>
          <span className="counter-label">Total Visits</span>
        </div>
      </div>
    );
  }
}

export default VisitorCounter;
